exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/object-get-own-property-symbols.js
// module id = 282
// module chunks = 3